<template>
  <div>
    <div class="--uppercase">
      {{ $t('tactics.instructions.outOfPossession.defensiveShape.defensiveShape') }}
    </div>

    <SelectTeamInstruction
      name="engagement-line"
      :value="engagementLine"
      mutation="updateEngagementLine"
      :options="options.engagementLine"
    >
      {{ $t('tactics.instructions.outOfPossession.defensiveShape.lineOfEngagement.lineOfEngagement') }}
    </SelectTeamInstruction>

    <SelectTeamInstruction
      name="defensive-line"
      :value="defensiveLine"
      mutation="updateDefensiveLine"
      :options="options.defensiveLine"
    >
      {{ $t('tactics.instructions.outOfPossession.defensiveShape.defensiveLine.defensiveLine') }}
    </SelectTeamInstruction>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SelectTeamInstruction from "@/components/SelectTeamInstruction";

export default {
  components: {
    SelectTeamInstruction
  },

  data: () => {
    return {
      options: {
        engagementLine: [
          {value: -1, label: "tactics.instructions.outOfPossession.defensiveShape.lineOfEngagement.lower"},
          {value: 0, label: "tactics.instructions.outOfPossession.defensiveShape.lineOfEngagement.standard"},
          {value: 1, label: "tactics.instructions.outOfPossession.defensiveShape.lineOfEngagement.higher"},
        ],
        defensiveLine: [
          {value: -2, label: "tactics.instructions.outOfPossession.defensiveShape.defensiveLine.muchLower"},
          {value: -1, label: "tactics.instructions.outOfPossession.defensiveShape.defensiveLine.lower"},
          {value: 0, label: "tactics.instructions.outOfPossession.defensiveShape.defensiveLine.standard"},
          {value: 1, label: "tactics.instructions.outOfPossession.defensiveShape.defensiveLine.higher"},
          {value: 2, label: "tactics.instructions.outOfPossession.defensiveShape.defensiveLine.muchHigher"}
        ],
      }
    };
  },

  computed: mapState({
    engagementLine: state => state.instructions.outOfPossession.defensiveShape.engagementLine,
    defensiveLine: state => state.instructions.outOfPossession.defensiveShape.defensiveLine,
  })
}
</script>

<style scoped>

</style>
